// Module
var code = "<html> <head> <style>body,html{margin:0;padding:0;height:100%;width:100%}.container{display:flex;justify-content:center;align-items:center;height:100%;width:100%}span{font-size:24px;color:#d3d3d3}</style> </head> <body> <div class=\"container\"> <span>Loading Run From Zip Site.</span> </div> </body> </html> ";
// Exports
module.exports = code;